// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.share-viewport[data-v-30097df8] {
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
}
.share-viewport.is-interactive[data-v-30097df8] {
  cursor: grab;
}
.share-viewport.is-interactive[data-v-30097df8]:active {
  cursor: grabbing;
}
.share-inner[data-v-30097df8] {
  width: 100%;
  height: 100%;
  transform-origin: center center;
  transition: transform 0.1s ease-out;
}
.share-video[data-v-30097df8] {
  width: 100%;
  height: 100%;
  object-fit: contain;
}`, "",{"version":3,"sources":["webpack://./src/SharedWeb/scripts/apps/video-engine/components/video-call/stage/shared/ScreenShareViewport.vue","webpack://./ScreenShareViewport.vue"],"names":[],"mappings":"AAEA;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;ACDF;ADIA;EACE,YAAA;ACDF;ADIA;EACE,gBAAA;ACDF;ADIA;EACE,WAAA;EACA,YAAA;EACA,+BAAA;EACA,mCAAA;ACDF;ADIA;EACE,WAAA;EACA,YAAA;EACA,mBAAA;ACDF","sourcesContent":["@import \"@/styles/breakpoint-mixin.scss\";\n\n.share-viewport {\n  position: relative;\n  width: 100%;\n  height: 100%;\n  overflow: hidden;\n}\n\n.share-viewport.is-interactive {\n  cursor: grab;\n}\n\n.share-viewport.is-interactive:active {\n  cursor: grabbing;\n}\n\n.share-inner {\n  width: 100%;\n  height: 100%;\n  transform-origin: center center;\n  transition: transform 0.1s ease-out;\n}\n\n.share-video {\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n}\n\n",".share-viewport {\n  position: relative;\n  width: 100%;\n  height: 100%;\n  overflow: hidden;\n}\n\n.share-viewport.is-interactive {\n  cursor: grab;\n}\n\n.share-viewport.is-interactive:active {\n  cursor: grabbing;\n}\n\n.share-inner {\n  width: 100%;\n  height: 100%;\n  transform-origin: center center;\n  transition: transform 0.1s ease-out;\n}\n\n.share-video {\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
